module.exports = __webpack_public_path__ + "static/media/blender_icon.2076e5e8.png";